export const FormSamplesCustomLayoutPageInfo = () => {
    return (
        <>
            You have full control over the layout, and can add any tags under the FormControl component formatting the content.
        </>
    )
}
